
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';

import { VideoJsPlayerStatus } from '@/interfaces/components/videojs-ima-player';

import { VideoJsPlayer } from '@/lazy-load-components';
import VideoPlayerWrapper from './VideoPlayerWrapper.vue';

import { Clip } from '@/@types/graphql-types';
import { PlayerIcon } from '@/enums/player-icon';

@Component({
	name: 'VideobusterPlayer',
	components: { VideoJsPlayer, VideoPlayerWrapper },
})
export default class VideobusterPlayer extends Vue {
	@Prop({ required: true }) clip: Clip;
	@Prop({ default: false }) isActive: boolean;
	@Prop({ default: false }) isBackdrop: boolean;
	@Prop({ default: null }) playIconType: PlayerIcon | null;

	@Emit('setActiveClipId')
	setActiveClipId(clipId: string | null) {
		return clipId;
	}

	play() {
		this.setActiveClipId(this.clip.externalId);
	}

	stateChanged(playerStatus: VideoJsPlayerStatus) {
		if (playerStatus === 'playing') {
			this.setActiveClipId(this.clip.externalId);
			this.$emit('onPlaying', this.clip);
		}

		if (playerStatus === 'pause') {
			this.$emit('onPaused', this.clip);
		}

		if (playerStatus === 'ended') {
			this.setActiveClipId(null);
			this.$emit('onEnded', this.clip);
		}

		if (playerStatus === 'waiting') {
			this.$emit('onBuffering', this.clip);
		}
	}
}
